/**
 * i18n Configuration
 *
 * Central configuration for internationalization.
 * Following the king-dom pattern from sign-git.
 */

export type Language = 'pt' | 'en'

export const SUPPORTED_LANGUAGES: Language[] = ['pt', 'en']

export const LANGUAGE_NAMES: Record<Language, string> = {
  pt: 'Portugues',
  en: 'English',
}

export const LANGUAGE_FLAGS: Record<Language, string> = {
  pt: '\u{1F1E7}\u{1F1F7}',
  en: '\u{1F1FA}\u{1F1F8}',
}

export const DEFAULT_LANGUAGE: Language = 'pt'

export const FALLBACK_CHAIN: Record<Language, Language[]> = {
  pt: ['en'],
  en: ['pt'],
}

export const INTERPOLATION_PATTERN = /\{\{(\w+)\}\}/g

export const STORAGE_KEY = 'recruitment_language'
